/**
 * Orval API Mutator - Axios 客户端配置
 *
 * 功能：
 * - 创建 Axios 实例
 * - 提供自定义实例包装器供 Orval 生成的代码使用
 * - 拦截器在 utils/request.ts 中配置
 */
import axios, { type AxiosRequestConfig, type AxiosInstance } from "axios";

/**
 * 创建 Axios 实例
 * 拦截器将在应用初始化时通过 setupInterceptors 配置
 */
export const apiClient: AxiosInstance = axios.create({
  baseURL: (import.meta as any).env.VITE_API_BASE_URL,
  timeout: 30000,
  headers: {
    "Content-Type": "application/json",
  },
});

/**
 * Orval 自定义实例包装器
 * 所有 Orval 生成的 API 函数都会使用这个包装器
 */
export const customInstance = <T>(
  config: AxiosRequestConfig,
  options?: AxiosRequestConfig
): Promise<T> => {
  return apiClient.request<T>({
    ...config,
    ...options,
  }) as Promise<T>;
};

export default apiClient;
